import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { startLoadingTopicQuestionLists } from "./catalogTopicQuestionActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingCatalogs = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOG}`, "get");
    const body = await resp.json();

     debugLogActions(':: catalogActions, startLoadingCatalogs', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogs(body.catalogs));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogs = (catalogs) => ({
  type: types.CATALOG_START_LOADING,
  payload: catalogs,
});

export const startLoadingCatalogsPaginated = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOG}`, `get/${page}/${size}`);
    const body = await resp.json();

     debugLogActions(':: catalogActions, startLoadingCatalogsPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogPaginated(body.catalogPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogsPaginatedByFilters = (page, size, catalogtype_id = -1) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOG}`, `getP/${page}/${size}/${catalogtype_id}`);
    const body = await resp.json();

     debugLogActions(':: catalogActions, startLoadingCatalogsPaginatedByFilters', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogPaginated(body.catalogPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogPaginated = (catalogPaginated) => ({
  type: types.CATALOG_START_LOADING_PAGINATED,
  payload: catalogPaginated,
});

export const selectCatalogs = (catalog) => ({
  type: types.CATALOG_SELECT,
  payload: catalog,
});

export const catalogClean = () => ({
  type: types.CATALOG_CLEAN,
});

export const catalogStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_CATALOG}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

               debugLogActions(':: catalogActions, catalogStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(catalogDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: catalogActions, catalogStartDelete', { 'error': error });
    }
  };
};

const catalogDeleted = (id) => {
  return {
    type: types.CATALOG_DELETE,
    payload: id,
  };
};

export const startSearchingCatalogPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOG}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

     debugLogActions(':: catalogActions, startSearchingCatalogPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingCatalogsPaginated(body.catalogsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingCatalogsPaginated = (catalogsPaginated) => ({
  type: types.CATALOG_START_SEARCH_PAGINATED,
  payload: catalogsPaginated,
});

export const cleanSearchingCatalogsPaginated = () => ({
  type: types.CATALOG_CLEAN_SEARCH_PAGINATED,
});

export const catalogStartUpdate = (catalog, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_CATALOG}`,
        `update/${catalog.id}`,
        catalog,
        "PUT"
      );
      const body = await resp.json();

       debugLogActions(':: catalogActions, catalogStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(catalogUpdated(catalog));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-catalog");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: catalogActions, catalogStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} catalog
 * @returns
 */
const catalogUpdated = (catalog) => {
  return {
    type: types.CATALOG_UPDATE,
    payload: catalog,
  };
};

export const catalogStartRegister = (catalog, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOG}`,
      "add",
      catalog,
      "POST"
    );

    const body = await resp.json();

      debugLogActions(':: catalogActions, catalogStartRegister', { 'body': body });

    if (body.ok) {
      dispatch(catalogRegister(body.catalog));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-catalog");
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const catalogRegister = (catalog) => ({
  type: types.CATALOG_START_REGISTER,
  payload: catalog,
});

export const catalogSetSearchText = (searchText) => ({
  type: types.CATALOG_SET_SEARCH_TEXT,
  payload: searchText,
});

export const catalogCleanSearchText = () => ({
  type: types.CATALOG_SET_SEARCH_TEXT,
});

/** Revision */
export const startLoadingCatalogsAll = (type) => {
     
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOG}`, `get`);
    const body = await resp.json();

     debugLogActions(':: catalogActions, startLoadingCatalogsAll', { 'body': body });

    if (body.ok) {
         
      dispatch(loadingCatalogAll(body.catalogs));
      dispatch(startLoadingTopicQuestionLists());
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingCatalogAll = (catalogs) => ({
  type: types.CATALOG_START_LOADING_ALL,
  payload: catalogs,
});

export const loadingCatalogFilter = (catalogs) => ({
  type: types.CATALOG_START_LOADING_FILTER,
  payload: catalogs,
});

export const startLoadingCatalogsByGroupVision = (group_id) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOG}`,`getConcernsByGroup/${group_id}`);
    const body = await resp.json();

     debugLogActions(':: catalogActions, startLoadingCatalogsByGroup', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogsByGroupVision(body.catalogs));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogsByGroupVision = (catalogs) => ({
  type: types.CATALOG_START_LOADING_BY_GROUP_VISION,
  payload: catalogs,
});

export const cleanCatalogConcernByGroupVision = () => ({
  type: types.CATALOG_CLEAN_CONCERN_BY_GROUP_VISION,
});

